import styled from 'styled-components';

export const TicketNumber = styled.span(() => ({
  fontWeight: 'bold',
}));
